import { FundTeaser } from '@/components/home/fund-teaser';
import { ApproachBand } from '@/components/home/approach-band';
import { BrainFacts } from '@/components/home/brain-facts';
import { EnableBand } from '@/components/home/enable-band';
import { HeroSection } from '@/components/home/hero-section';
import { ProjectTiles } from '@/components/home/project-tiles';
import { StatsBand } from '@/components/home/stats-band';
import { TestimonialCarousel } from '@/components/home/testimonial-carousel';

/**
 * Homepage mirrors ICONIQ Impact rhythm on NextOnVera content:
 * Hero → Our Model → Initiatives → Proof → Insights → Enable → Engage
 */
export function HomePage() {
  return (
    <div className="flex flex-col">
      <HeroSection />
      <ApproachBand />
      <ProjectTiles />
      <EnableBand />
      <StatsBand />
      <BrainFacts />
      <TestimonialCarousel />
      <FundTeaser />
    </div>
  );
}
